export function guardFall(str) {
  const reg = /^SR\d{6}$/;
  return reg.test(str);
}
